export function orderedSlider() {
  $('.ordered-slider-section').each(function () {

    let
      section = $(this),
      slider = section.find('.ordered-slider'),
      progressbar = section.find('.ordered-slider-progressbar > div'),
      progressbarCalc = function (itemsList) {
        let
          itemsLength = itemsList.length,
          i = itemsLength - 1;

        for (i; i >= 0; i--) {
          if ($(itemsList[i]).hasClass('slick-active')) { //work only afterChange event
            progressbar.css('width', ((i + 1) * 100 / itemsLength) + '%');
            break;
          }
        }
      };

    slider.on('init', function (event, slick) {
      progressbarCalc(slick.$slides);

    }).slick({
      prevArrow: '<div class="slick-prev prev"></div>',
      nextArrow: '<div class="slick-next next"></div>',
      appendArrows: section.find('.ordered-slider-nav'),
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
      progressbarCalc(slick.$slides);
    });
  })
}


// WEBPACK FOOTER //
// ./assets/js/modules/orderedSlider.js